import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=6d094e7d&scoped=true&"
import script from "./createModal.vue?vue&type=script&lang=ts&"
export * from "./createModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d094e7d",
  null
  
)

export default component.exports